import NoResultIcon from '@/common/assets/icons/NoResult-vheicle-part.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import { Box } from 'styled-system/jsx';

const VehicleImagesEmptySpace = () => {
  return (
    <Box
      width="100%"
      height={140}
      border="1px dashed"
      borderColor="gray-1"
      borderRadius="12px"
      display="flex"
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      gap={12}
    >
      <NoResultIcon />
      <Typography color="black-3" textStyle="b2">
        تصویری ثبت نشده است!
      </Typography>
    </Box>
  );
};

export default VehicleImagesEmptySpace;
